var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExterior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M240 426c5.52 0 10-4.48 10-10s-4.48-10-10-10-10 4.48-10 10 4.48 10 10 10zM390 366h-60c-5.523 0-10 4.477-10 10v60c0 5.523 4.477 10 10 10h60c5.523 0 10-4.477 10-10v-60c0-5.523-4.477-10-10-10zm-10 60h-40v-40h40zM150 126H90c-5.523 0-10 4.477-10 10v60c0 5.523 4.477 10 10 10h60c5.523 0 10-4.477 10-10v-60c0-5.523-4.477-10-10-10zm-10 60h-40v-40h40zM270 126h-60c-5.523 0-10 4.477-10 10v60c0 5.523 4.477 10 10 10h60c5.523 0 10-4.477 10-10v-60c0-5.523-4.477-10-10-10zm-10 60h-40v-40h40zM320 136v60c0 5.523 4.477 10 10 10h60c5.523 0 10-4.477 10-10v-60c0-5.523-4.477-10-10-10h-60c-5.523 0-10 4.477-10 10zm20 10h40v40h-40zM150 246H90c-5.523 0-10 4.477-10 10v60c0 5.523 4.477 10 10 10h60c5.523 0 10-4.477 10-10v-60c0-5.523-4.477-10-10-10zm-10 60h-40v-40h40zM270 246h-60c-5.523 0-10 4.477-10 10v60c0 5.523 4.477 10 10 10h60c5.523 0 10-4.477 10-10v-60c0-5.523-4.477-10-10-10zm-10 60h-40v-40h40zM390 246h-60c-5.523 0-10 4.477-10 10v60c0 5.523 4.477 10 10 10h60c5.523 0 10-4.477 10-10v-60c0-5.523-4.477-10-10-10zm-10 60h-40v-40h40zM150 366H90c-5.523 0-10 4.477-10 10v60c0 5.523 4.477 10 10 10h60c5.523 0 10-4.477 10-10v-60c0-5.523-4.477-10-10-10zm-10 60h-40v-40h40zm0 0",
    fill: "#19022B",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 0H110c-5.523 0-10 4.477-10 10v56H50c-5.523 0-10 4.477-10 10v416H10c-5.523 0-10 4.477-10 10s4.477 10 10 10h460c5.523 0 10-4.477 10-10s-4.477-10-10-10h-30V76c0-5.523-4.477-10-10-10h-50V10c0-5.523-4.477-10-10-10zM120 20h240v46H120zm160 472h-30v-36c0-5.523-4.477-10-10-10s-10 4.477-10 10v36h-30V386h80zm140 0H300V376c0-5.523-4.477-10-10-10H190c-5.523 0-10 4.477-10 10v116H60V86h360zm0 0",
    fill: "#19022B",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExterior);
export default __webpack_public_path__ + "static/media/icon-exterior.1e5c3078b3cfacf1cf653c7c2f305a1f.svg";
export { ForwardRef as ReactComponent };